import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Group, List, Text } from "@mantine/core";

export const RankedExplanations: React.FC = () => {
  const { t } = useAppTranslation("components.rankedExplanations");
  const { currentRegion } = useAppRegion();

  return (
    <div className="px-2 pt-20 md:px-20">
      <Text className="text-[16px] text-secret-blue-default">{t("lol")}</Text>
      <Text className="py-2 font-bold text-[36px] text-primary-white">
        {t("whyBuy.title", { region: currentRegion.toUpperCase() })}
      </Text>
      <List
        classNames={{
          root: "font-inter text-[16px] text-primary-dark-text space-y-4",
          item: "marker:text-primary-light-text marker:font-bold",
        }}
        listStyleType="numeric"
      >
        <List.Item>
          <strong className="text-primary-light-text">
            {t("whyBuy.reasons.timeSaving.title")}
          </strong>{" "}
          {t("whyBuy.reasons.timeSaving.text")}
        </List.Item>
        <List.Item>
          <strong className="text-primary-light-text">
            {t("whyBuy.reasons.higherLevels.title")}{" "}
          </strong>
          {t("whyBuy.reasons.higherLevels.text")}
        </List.Item>
        <List.Item>
          <strong className="text-primary-light-text">
            {t("whyBuy.reasons.seasonalRewards.title")}{" "}
          </strong>
          {t("whyBuy.reasons.seasonalRewards.text")}
        </List.Item>
        <List.Item>
          <strong className="text-primary-light-text">
            {t("whyBuy.reasons.avoidPlacements.title")}{" "}
          </strong>
          {t("whyBuy.reasons.avoidPlacements.text")}
        </List.Item>
      </List>
      <Group align="top" className="pt-10 md:flex-nowrap">
        <div>
          <Text className="pb-2 font-bold text-[20px] text-primary-white">
            {t("security.title")}
          </Text>
          <Text className="font-inter text-[16px] text-primary-dark-text">
            {t("security.text")}
          </Text>
        </div>
        <div>
          <Text className="pb-2 font-bold text-[20px] text-primary-white">
            {t("howToBuy.title")}
          </Text>
          <Text className="font-inter text-[16px] text-primary-dark-text">
            {t("howToBuy.intro")}
          </Text>
          <List
            classNames={{
              root: "font-inter text-[16px] text-primary-dark-text",
            }}
            listStyleType="numeric"
          >
            <List.Item>{t("howToBuy.steps.0")}</List.Item>
            <List.Item>{t("howToBuy.steps.1")}</List.Item>
            <List.Item>{t("howToBuy.steps.2")}</List.Item>
            <List.Item>{t("howToBuy.steps.3")}</List.Item>
          </List>
        </div>
      </Group>
    </div>
  );
};
